'use client';

import { jsx } from "react/jsx-runtime";
import { classNames } from "../../utils/styles/classNames.js";
import { onLight, overlay } from "./Modal.css.js";
function Overlay({ onClick }) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ jsx("div", { className: classNames(overlay, onLight), onClick })
  );
}
export {
  Overlay
};
